import React, { useEffect } from 'react';
import { Accordion, Card, Form } from 'react-bootstrap';
import { Link } from 'react-router-dom';

//Nouislider
import Nouislider from "nouislider-react";
import "../../../../node_modules/nouislider/distribute/nouislider.css";
import { useCategoryListMutation } from '../../../Redux/category/categoryApi';
import ProductSelectColor from './ProductSelectColor';
import ProductSize from './ProductSize';

const ProductCategoryFilter = ({ mincost, setMincost, maxcost, setMaxcost, selectedCategry, setSelectedCategory, selectedColors, setSelectedColors, selectedSizes, setSelectedSizes,limit,page,setPage,setlimit,search,setSearch }) => {

    const [categoryListFn, { data: listData, error: listErr, isLoading: listLoading }] = useCategoryListMutation();


    //Product Filter
    const onUpdate = (value) => {
        setMincost(value[0]);
        setMaxcost(value[1]);
    }
    useEffect(() => {
        onUpdate([0, 5000]);
        categoryListFn()
    }, []);
    return (
        <React.Fragment>
            <Accordion flush defaultActiveKey="0" className="filter-accordion">

                <Accordion defaultActiveKey='0'>
                    <Accordion.Item eventKey='0'>
                        <Accordion.Header>
                            <span className="text-muted text-uppercase fs-13">Category</span>
                        </Accordion.Header>

                        <Accordion.Body className="text-body">
                            <Card.Body className="border-bottom">
                                <div>
                                    <ul className="list-unstyled mb-0 filter-list">
                                        {listData?.response?.map(cat => {
                                            const isExit = selectedCategry?.includes(cat?.id)

                                            return <li className={`d-flex `} key={cat?.id}>
                                                <Form.Check type="checkbox" value="40" id="productdiscountRadio5" checked={isExit} onChange={e => {
                                                 
                                                
                                                    setPage(1)
                                                  
                                                 setSelectedCategory(isExit ? selectedCategry?.filter(c => c !== cat?.id) : [...selectedCategry, cat?.id])
                                                }} />
                                                <Link to="#" className="pe-2 d-flex py-1 align-items-center " onClick={() => {


    setPage(1)
  
                                                    setSelectedCategory(isExit ? selectedCategry?.filter(c => c !== cat?.id) : [...selectedCategry, cat?.id])
                                                }}>
                                                    <div className="flex-grow-1">
                                                        <h6 className="mb-0 listname ms-2">{cat?.name}</h6>
                                                    </div>
                                                </Link>
                                            </li>
                                        })}


                                    </ul>
                                </div>
                            </Card.Body>
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>


                <Card.Body className="border-bottom">
                    <p className="text-muted text-uppercase fs-13 mb-3">
                        Price
                    </p>

                    <Nouislider
                        range={{ min: 0, max: 1980 }}
                        start={[mincost, maxcost]}
                        connect
                        onSlide={onUpdate}
                        data-slider-color="info"
                        id="product-price-range"
                    />
                    <div className="formCost d-flex gap-2 align-items-center mt-3">
                        <input type="text" className="form-control form-control-sm" id="MinCost" value={mincost} onChange={(e) => setMincost(e.target.value)} />
                        <span className="fw-semibold text-muted">to</span>
                        <input className="form-control form-control-sm" type="text" id="maxCost" value={maxcost} onChange={(e) => setMaxcost(e.target.value)} />
                    </div>
                </Card.Body>

                {/* ProductSelectColor */}
                <Accordion.Item eventKey="0">
                    <ProductSelectColor      setPage={setPage}
        page={page}
        limit={limit}
        setlimit={setlimit}
        search={search}
        setSearch={setSearch} selectedColors={selectedColors} setSelectedColors={setSelectedColors} />
                </Accordion.Item>

                {/* ProductSize */}
                <ProductSize
                     setPage={setPage}
                     page={page}
                     limit={limit}
                     setlimit={setlimit}
                     search={search}
                     setSearch={setSearch}
                setSelectedSizes={setSelectedSizes} selectedSizes={selectedSizes} />

                {/* ProductDiscount */}
                {/* <ProductDiscount /> */}

                {/* ProductRating */}
                {/* <ProductRating /> */}
            </Accordion>
        </React.Fragment>
    )
}

export default ProductCategoryFilter
